import { render, staticRenderFns } from "./salesSummaryWidget.vue?vue&type=template&id=48bf268c&"
import script from "./salesSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./salesSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports